module.exports = __webpack_public_path__ + "img/way_image_04.6345038.svg";